// File: src/English/EnglishTool/advancedNounQuestions.js

import { shuffleArray } from "./shuffleArray.js";

/* ========== GERUND MC QUESTIONS ========== */

// Q1
export function buildGerundNounMC() {
  return {
    questionType: "MC",
    question: "Which word is a gerund (a verb used as a noun) in this sentence? 'Swimming is my favorite activity.'",
    correctAnswer: "Swimming",
    options: shuffleArray([
      "Swimming",
      "favorite",
      "activity",
      "is"
    ])
  };
}

// Q2
export function buildGerundNounMC2() {
  return {
    questionType: "MC",
    question: "Identify the gerund in: 'Reading helps you learn new things.'",
    correctAnswer: "Reading",
    options: shuffleArray([
      "Reading",
      "helps",
      "learn",
      "things"
    ])
  };
}

// Q3
export function buildGerundNounMC3() {
  return {
    questionType: "MC",
    question: "Which word in the sentence is a gerund? 'My hobby is drawing.'",
    correctAnswer: "drawing",
    options: shuffleArray([
      "drawing",
      "hobby",
      "is",
      "My"
    ])
  };
}

// Q4 (Trickier)
export function buildGerundNounMC4() {
  return {
    questionType: "MC",
    question: "Which is used as a gerund in this sentence? 'She enjoys baking more than cooking.'",
    correctAnswer: "baking",
    options: shuffleArray([
      "baking",
      "cooking",
      "enjoys",
      "more"
    ])
  };
}

// Identify Type (comma-separated)
export function buildGerundIdentify() {
  return {
    questionType: "IDENTIFY",
    question: "Type all gerunds in this sentence, separated by commas: 'Running and jumping are great exercises.'",
    correctAnswers: ["Running", "jumping"]
  };
}

/* ========== NOMINALIZATION MC QUESTIONS ========== */

// Q1
export function buildNominalizationMC() {
  return {
    questionType: "MC",
    question: "Which noun in this sentence is formed from a verb or adjective? 'Her decision was quick.'",
    correctAnswer: "decision",
    options: shuffleArray([
      "decision",
      "her",
      "was",
      "quick"
    ])
  };
}

// Q2
export function buildNominalizationMC2() {
  return {
    questionType: "MC",
    question: "Which noun in this sentence is a nominalization? 'The teacher appreciated his explanation.'",
    correctAnswer: "explanation",
    options: shuffleArray([
      "explanation",
      "teacher",
      "his",
      "appreciated"
    ])
  };
}

// Q3
export function buildNominalizationMC3() {
  return {
    questionType: "MC",
    question: "Which noun is a nominalization of the verb 'to succeed' in this sentence? 'Success requires effort.'",
    correctAnswer: "Success",
    options: shuffleArray([
      "Success",
      "requires",
      "effort",
      "verb"
    ])
  };
}

// Q4
export function buildNominalizationMC4() {
  return {
    questionType: "MC",
    question: "Which noun is a nominalization in this sentence? 'His happiness was obvious.'",
    correctAnswer: "happiness",
    options: shuffleArray([
      "happiness",
      "obvious",
      "was",
      "His"
    ])
  };
}

// Identify Type
export function buildNominalizationIdentify() {
  return {
    questionType: "IDENTIFY",
    question: "Type all nominalizations in this sentence, separated by commas: 'The discovery and improvement of the method led to excitement.'",
    correctAnswers: ["discovery", "improvement", "excitement"]
  };
}

/* ========== APPOSITIVE MC QUESTION (EXTRA) ========== */

export function buildAppositiveMC() {
  return {
    questionType: "MC",
    question: "Which part of the sentence is the appositive? 'My friend, a talented musician, plays piano.'",
    correctAnswer: "a talented musician",
    options: shuffleArray([
      "a talented musician",
      "My friend",
      "plays piano",
      "the sentence has no appositive"
    ])
  };
}

// Identify Type for Appositive (bonus)
export function buildAppositiveIdentify() {
  return {
    questionType: "IDENTIFY",
    question: "Type the appositive in the sentence: 'The insect, a ladybug, landed on my finger.'",
    correctAnswers: ["a ladybug"]
  };
}

/* ========== EXPORT AS A POOL FOR EASY RANDOMIZATION ========== */

export const allAdvancedNounQuestions = [
  buildGerundNounMC,
  buildGerundNounMC2,
  buildGerundNounMC3,
  buildGerundNounMC4,
  buildGerundIdentify,
  buildNominalizationMC,
  buildNominalizationMC2,
  buildNominalizationMC3,
  buildNominalizationMC4,
  buildNominalizationIdentify,
  buildAppositiveMC,
  buildAppositiveIdentify
];
